import React from 'react';
import type { CanvasObject } from '../../types';
import type { Artboard } from '../../hooks/useCanvasTransform';
import { useAlign, type AlignMode } from '../../hooks/useAlign';
import { AlignIcon } from './AlignIcon';

interface AlignToolbarProps {
  selectedObjects: CanvasObject[];
  updateObject: (id: string, updater: (obj: CanvasObject) => CanvasObject) => void;
  requestRender: () => void;
  saveToHistory: (state: { objects: Map<string, CanvasObject>; zOrder: string[]; selectedId: string | null }) => void;
  objects: Map<string, CanvasObject>;
  zOrder: string[];
  selectedId: string | null;
  artboardsMap: Map<string, Artboard>;
}

export const AlignToolbar: React.FC<AlignToolbarProps> = ({
  selectedObjects,
  updateObject,
  requestRender,
  saveToHistory,
  objects,
  zOrder,
  selectedId,
  artboardsMap
}) => {
  const { align } = useAlign({
    selectedObjects,
    updateObject,
    requestRender,
    saveToHistory,
    objects,
    zOrder,
    selectedId,
    artboardsMap
  });
  
  const canAlign = selectedObjects.length > 0;
  const canDistribute = selectedObjects.length >= 2;
  
  const mkBtn = (
    iconType: AlignMode,
    title: string,
    mode: AlignMode,
    disabled?: boolean
  ) => {
    const isDisabled = disabled ?? !canAlign;
    return (
      <button 
        type="button" 
        className="bottom-toolbar__button" 
        title={title} 
        onClick={() => align(mode)} 
        disabled={isDisabled} 
        style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          width: '32px', 
          height: '32px', 
          padding: 0, 
          opacity: isDisabled ? 0.5 : 1, 
          cursor: isDisabled ? 'not-allowed' : 'pointer' 
        }}
      >
        <AlignIcon type={iconType} disabled={isDisabled} />
      </button>
    );
  };
  
  return (
    <div className="align-toolbar" style={{ position: 'absolute', top: 8, right: 10, display: 'flex', gap: 6 }}>
      {mkBtn('left', '좌측 정렬', 'left')}
      {mkBtn('hcenter', '가로 가운데', 'hcenter')}
      {mkBtn('right', '우측 정렬', 'right')}
      {mkBtn('distribute-h', '가로 균등 배치', 'distribute-h', !canDistribute)}
      {mkBtn('top', '상단 정렬', 'top')}
      {mkBtn('vcenter', '세로 가운데', 'vcenter')}
      {mkBtn('bottom', '하단 정렬', 'bottom')}
      {mkBtn('distribute-v', '세로 균등 배치', 'distribute-v', !canDistribute)}
    </div>
  );
};

